// src/Component/Application/Identification/IdentificationContainer.tsx

import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import IdentificationList from './IdentificationList';
import IdentificationModal from './IdentificationModal';
import { Identification } from './types';

const IdentificationContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Identification | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const handleOpenAdd = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleOpenEdit = (item: Identification) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setRefreshTrigger(prev => !prev); // triggers data refresh
  };

  return (
    <>
      <Breadcrumbs mainTitle="Identifications" parent="Core Settings" />
      <Container fluid>
        <Row>
          <Col md="12">
            <IdentificationList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              refresh={refreshTrigger}
            />
          </Col>
        </Row>
        <IdentificationModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedItem}
        />
      </Container>
    </>
  );
};

export default IdentificationContainer;
